import { render, staticRenderFns } from "./OptionalFormItem.vue?vue&type=template&id=238b3627"
import script from "./OptionalFormItem.vue?vue&type=script&lang=js"
export * from "./OptionalFormItem.vue?vue&type=script&lang=js"
import style0 from "./OptionalFormItem.vue?vue&type=style&index=0&id=238b3627&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports